<template>
  <div class="form">
    <h1>Na pewno chcesz usunąć komentarz?</h1>
    <button class="delete-btn" @click.prevent="deleteComment(deletedCommentId)">Usuń</button>
    <button class="cancel-btn" @click.prevent="isCommentDeleteModal = false">Anuluj</button>
  </div>
</template>

<script>
export default {

};
</script>

<style>

</style>
